import request from '@/utils/request'

let BannerApi = {
  /*列表*/
   bannerList(data) {
    return request._post('/shop/plus.banner.banner/index', data);
  },
  /*添加*/
  addBanner(data) {
    return request._post('/shop/plus.banner.banner/add', data);
  },
  /*获取数据*/
  getBanner(data) {
    return request._get('/shop/plus.banner.banner/edit', data);
  },

  /*保存*/
  saveBanner(data) {
    console.log(data)
    return request._post('/shop/plus.banner.banner/edit', data);
  },
  /*删除*/
  delBanner(data) {
    return request._post('/shop/plus.banner.banner/delete', data);
  },

}
export default BannerApi;



// WEBPACK FOOTER //
// ./src/api/banner.js